import { Bars } from "@gravity-ui/icons";
import {
  Button,
  DropdownMenu,
  Icon,
  Text,
  useThemeValue,
} from "@gravity-ui/uikit";
import cn from "classnames";
import { ReactElement, useCallback } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { appConfig } from "src/config";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { ILink } from "src/types";

import css from "./Header.module.scss";

interface HeaderProps {
  links?: ILink[];
  actions?: ReactElement;
  actionsMobile?: ReactElement;
}

const MobileMenu = ({ links, actions, actionsMobile }: HeaderProps) => {
  return (
    <div className={css.mobileMenu}>
      <div className={css.links}>
        {links?.map((link, index) => (
          <RouterLink className={css.link} to={link.path} key={index}>
            {link.name}
          </RouterLink>
        ))}
        {actionsMobile ? (
          <>{actionsMobile}</>
        ) : (
          <RouterLink className={css.link} to={"/knowledge-base"}>
            Документация
          </RouterLink>
        )}
      </div>
      {actions}
    </div>
  );
};
const Menu = ({ links, actions, actionsMobile }: HeaderProps) => {
  return (
    <>
      <div className={cn(css.links, css.hideMobile)}>
        {links?.map((link, index) => (
          <RouterLink className={css.navLink} to={link.path} key={index}>
            <Text className={css.navText}>{link.name}</Text>
          </RouterLink>
        ))}
      </div>
      {actions && (
        <div className={cn(css.hideMobile, css.actions)}>{actions}</div>
      )}
      <div className={cn(css.actionsBurger, css.showMobile)}>
        <DropdownMenu
          renderSwitcher={(props) => (
            <Button {...props} view={"flat"} size={"xl"}>
              <Icon data={Bars} size={40} />
            </Button>
          )}
          popupProps={{ className: css.popup }}
        >
          <MobileMenu
            links={links}
            actions={actions}
            actionsMobile={actionsMobile}
          />
        </DropdownMenu>
      </div>
    </>
  );
};

export const Header = ({ links, actions, actionsMobile }: HeaderProps) => {
  const history = useNavigate();

  const theme = useThemeValue();

  const onClickLogo = useCallback(() => {
    history(RoutesPaths.LANDING);
  }, [history]);

  return (
    <div className={css.container}>
      <nav className={css.nav}>
        <div className={css.navContent}>
          <div className={css.logoSection}>
            <RouterLink className={css.logoLink} to={RoutesPaths.LANDING}>
              <appConfig.logo
                fill={theme === "light" ? "black" : "white"}
                onClick={onClickLogo}
                className={css.logoImage}
              />
            </RouterLink>
          </div>

          <Menu links={links} actions={actions} actionsMobile={actionsMobile} />
        </div>
      </nav>
    </div>
  );
};
